import { css } from '@emotion/react'
import styles, { typo } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const {
  colors: { gray, blue },
} = styles

const S = {
  defaultBadgeStyle: css`
    border-radius: var(--Radius-100);
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: max-content;
    font-weight: 700;
    width: fit-content;
  `,
  theme: {
    new: css`
      font-weight: 700;
      color: ${colors.blue.$300};
    `,
    solid: css`
      padding: 4px;
      color: #ffffff;
      ${typo.caption02};
      font-weight: 700;
      background: ${colors.gray.$600};
    `,
    twin: css`
      padding: 2px 4px;
      background-color: ${blue.$300};
      color: #ffffff;
      ${typo.caption02};
      font-weight: 700;
    `,
    autoScorable: css`
      width: 48px;
      background-color: ${gray.$600};
      color: #ffffff;
      ${typo.caption02};
      font-weight: 700;
      transform: scale(0.9);
    `,
    private: css`
      padding: 2px 4px;
      background: ${colors.deepGreen};
      color: #ffffff;
      ${typo.caption02};
      font-weight: 700;
    `,
    repProblem: css`
      color: #ffffff;
      ${typo.caption02};
      font-weight: 700;
      padding: 2px 4px;
      background: ${colors.gray.$700};
    `,
    darkGray: css`
      ${typo.caption02};
      color: #ffffff;
      font-weight: 700;
      background-color: ${colors.gray.$900};
    `,
    blue: css`
      ${typo.caption02};
      color: #ffffff;
      font-weight: 700;
      background-color: ${colors.blue.$500};
    `,
  },
  size: {
    small: css`
      ${typo.caption02};
      padding: 2px 4px;
      height: 16px;
    `,
    large: css`
      ${typo.caption01};
      padding: 2px 4px;
    `,
  },
  border: css`
    border: 1px solid ${gray.$400};
    border-radius: var(--Radius-100);
  `,
}
export default S
